var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCardRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.571,
    height: 16,
    viewBox: "0 0 20.571 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "credit-card-regular",
    d: "M18.854,32H1.718A1.715,1.715,0,0,0,0,33.714V46.286A1.715,1.715,0,0,0,1.718,48H18.854a1.715,1.715,0,0,0,1.718-1.714V33.714A1.715,1.715,0,0,0,18.854,32ZM1.932,33.714H18.639a.215.215,0,0,1,.214.214v1.5H1.718v-1.5A.215.215,0,0,1,1.932,33.714ZM18.639,46.286H1.932a.215.215,0,0,1-.214-.214V40H18.854v6.071A.215.215,0,0,1,18.639,46.286ZM6.857,42.714v1.429a.43.43,0,0,1-.429.429H3.857a.43.43,0,0,1-.429-.429V42.714a.43.43,0,0,1,.429-.429H6.429A.43.43,0,0,1,6.857,42.714Zm6.857,0v1.429a.43.43,0,0,1-.429.429H8.429A.43.43,0,0,1,8,44.143V42.714a.43.43,0,0,1,.429-.429h4.857A.43.43,0,0,1,13.714,42.714Z",
    transform: "translate(0 -32)",
    fill: "#333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardRegular);
export default __webpack_public_path__ + "static/media/credit-card-regular.c97e3c92.svg";
export { ForwardRef as ReactComponent };